import { AutoAwesome } from '@mui/icons-material';
import { Button, type ButtonProps, IconButton } from '@mui/material';
import { Tooltip } from '@side/pantry';
import { useState } from 'react';
import { AIInsightsPanel } from './AIInsightsPanel';

export const AIInsightsButton = ({
  id = 'ai-insights-button',
  viewReportAs,
  showOnlyIcon,
  size,
  buttonLabel,
}: {
  id?: string;
  viewReportAs: string;
  showOnlyIcon?: boolean;
  size?: ButtonProps['size'];
  buttonLabel?: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const label = buttonLabel ?? 'AI Insights';

  return (
    <>
      {showOnlyIcon ? (
        <Tooltip title={label}>
          <IconButton
            id={id}
            aria-label={label}
            onClick={() => setIsOpen(true)}
            sx={(t) => ({
              borderRadius: '2px',
              border: `1.5px solid ${t.palette.other.outlineBorder}`,
              backgroundColor: t.palette.common.white,
              height: size === 'small' ? '31px' : '40px',
              width: size === 'small' ? '31px' : '40px',
              '&:hover': {
                backgroundColor: t.palette.common.white,
              },
            })}
            size={size === 'small' ? 'small' : 'medium'}
          >
            <AutoAwesome fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          id={id}
          variant="outlined"
          color="utility"
          size={size}
          startIcon={<AutoAwesome />}
          sx={{
            minWidth: 0,
            whiteSpace: 'nowrap',
            flexShrink: 0,
            '& .MuiButton-startIcon': {
              mr: 0.75,
            },
            '& .MuiButton-startIcon + *': {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
          }}
          onClick={() => setIsOpen(true)}
        >
          {label}
        </Button>
      )}
      <AIInsightsPanel
        open={isOpen}
        onClose={() => setIsOpen(false)}
        viewReportAs={viewReportAs}
      />
    </>
  );
};
